import React, { useEffect, useState } from 'react';
import Card11 from '../components/Card11';
import Card12 from '../components/Card12';
import Card13 from '../components/Card13';
import Card14 from '../components/Card14';
import Card28 from '../components/Card28';
import Graph1 from '../components/Graph1';
import Camembert1 from '../components/Camembert1';
import './Relationclient.css';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

// ★ RÉGLAGES LARGEURS — Card12 (commande_en_rupture)
const COLUMN_WIDTHS_RUPTURE = {
  'Horizon':             '80px',
  'MAD':                '120px',
  'Item':               '150px',
  'Description':        '260px',
  'Commande':            '90px',
  'Numero de commande': '130px',
  'Numero de ligne':     '80px',
  'Client':             '120px',
  'Stock':               '70px',
  'Rupture':             '80px',
};
const DEFAULT_WIDTH_RUPTURE = '110px';

// ★ RÉGLAGES LARGEURS — Card14 (commande_en_retard)
const COLUMN_WIDTHS_RETARD = {
  'Horizon':                  '80px',
  'Date de livraison prevue': '130px',
  'Client':                   '130px',
  'Numero de commande':       '130px',
  'Numero de ligne':           '80px',
  'Item':                     '150px',
  'Description':              '260px',
  'Commande':                  '90px',
};
const DEFAULT_WIDTH_RETARD = '110px';

const Relationclient = () => {
  useEffect(() => {
    document.title = 'MYSSA – Relation client';
  }, []);

  const [card11Hovered, setCard11Hovered] = useState(false);
  const [card12Hovered, setCard12Hovered] = useState(false);
  const [card13Hovered, setCard13Hovered] = useState(false);
  const [card14Hovered, setCard14Hovered] = useState(false);
  const [card28Hovered, setCard28Hovered] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [currentSource, setCurrentSource] = useState('');
  const [pdfBtnHovered, setPdfBtnHovered] = useState(false);

  // ---------------------------
  // CHARGEMENT DES DONNÉES
  // ---------------------------
  const handleCardClick = (source) => {
    setCurrentSource(source);
    let url;
    if (['commande_a_10_jours', 'commande_en_retard', 'commande_en_rupture', 'offre', 'taches'].includes(source)) {
      url = `${API}/${source}`;
    } else {
      url = process.env.PUBLIC_URL + '/' + source;
    }

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error(`Erreur réseau: ${res.statusText}`);
        return res.json();
      })
      .then((data) => {
        if (source === 'commande_a_10_jours' && Array.isArray(data)) {
          data = [...data].sort((a, b) =>
            new Date(a['Date de livraison prevue']) - new Date(b['Date de livraison prevue'])
          );
        }
        if (source === 'taches') {
          data = data
            .filter(row =>
              String(row['Departement'] || row['Département']).toUpperCase() === 'ADV' &&
              ['ouvert', 'en cours'].includes(String(row['Statut'] || '').toLowerCase())
            )
            .sort((a, b) => new Date(a['Date'] || 0) - new Date(b['Date'] || 0));
        }
        setTableData(data);
        setShowTable(true);
      })
      .catch((err) => {
        console.error(`Erreur de chargement ${source}:`, err);
        setTableData([]);
        setShowTable(false);
      });
  };

  // ---------------------------
  // RENDER TABLE OFFRE (Card11)
  // ---------------------------
  const renderTableOffre = () => {
    if (!tableData.length) return <p>Aucune donnée à afficher</p>;
    const columns = [
      "Numéro d'offre", "Client", "Date de création",
      "Date de Validité", "Date demandée", "Ptot", "Statut"
    ];

    return (
      <table className="table-offre">
        <thead>
          <tr>{columns.map((col, i) => <th key={i}>{col}</th>)}</tr>
        </thead>
        <tbody>
          {tableData.map((row, i) => (
            <tr key={i}>
              {columns.map((col, j) => {
                let value = row[col];
                let style = {};
                if (col === 'Statut') {
                  if (value === 'Analyse de faisabilité') style.backgroundColor = '#d4edda';
                  else if (value === 'Attente signature client') style.backgroundColor = '#fff3cd';
                }
                if (col === 'Date de Validité' && value) {
                  if (new Date(value) < new Date()) style.backgroundColor = '#f8d7da';
                }
                if (value && ['Date de création', 'Date de Validité', 'Date demandée'].includes(col)) {
                  value = new Date(value).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
                }
                if (col === 'Ptot' && value != null) {
                  value = Number(value).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
                }
                return <td key={j} style={style}>{value}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  // ---------------------------
  // RENDER TABLE GÉNÉRIQUE
  // ---------------------------
  const renderTable = () => {
    if (!tableData.length) return <p>Aucune donnée à afficher</p>;

    const columns = Object.keys(tableData[0])
      .filter(col => !['ID', 'Client_id', 'Departement', 'Département'].includes(col));

    const columnLabels =
      currentSource === 'commande_en_rupture'
        ? { MAD: 'Date de livraison prévue', Description: 'Déscription', Commande: 'Qté commandé' }
        : currentSource === 'commande_a_10_jours'
        ? { 'Numero de commande': 'Numéro de commande', 'Date de livraison prevue': 'Date de livraison prévue' }
        : currentSource === 'commande_en_retard'
        ? {
            'Numero de commande': 'Numéro de commande',
            'Date de livraison prevue': 'Date de livraison prévue',
            'Numero de ligne': 'N° de ligne',
            Description: 'Déscription',
            Commande: 'Qté commandé',
          }
        : currentSource === 'taches'
        ? { Description: 'Déscription' }
        : {};

    const widthMap =
      currentSource === 'commande_en_rupture' ? COLUMN_WIDTHS_RUPTURE :
      currentSource === 'commande_en_retard'  ? COLUMN_WIDTHS_RETARD  :
      null;

    const defaultW =
      currentSource === 'commande_en_rupture' ? DEFAULT_WIDTH_RUPTURE :
      currentSource === 'commande_en_retard'  ? DEFAULT_WIDTH_RETARD  :
      null;

    const tableTotal = widthMap
      ? columns.reduce((s, c) => s + parseInt(widthMap[c] || defaultW, 10), 0)
      : null;

    return (
      <table
        className="table-offre"
        style={widthMap ? { tableLayout: 'fixed', width: `${tableTotal}px` } : {}}
      >
        {widthMap && (
          <colgroup>
            {columns.map(c => (
              <col key={c} width={widthMap[c] || defaultW} />
            ))}
          </colgroup>
        )}

        <thead>
          <tr>
            {columns.map((col, i) => (
              <th key={i} className={`col-${col.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')}`}>
                {columnLabels[col] || col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, i) => (
            <tr key={i}>
              {columns.map((col, j) => {
                let value = row[col];
                let style = {};

                if (col === 'Horizon' || col === 'horizon') {
                  if (value === 'Retard') style.backgroundColor = '#fee2e2';
                  else if (value === 'J') style.backgroundColor = '#fef9c3';
                  else style.backgroundColor = '#dcfce7';
                }

                if (value && (col.toLowerCase().includes('date') || (currentSource === 'commande_en_rupture' && col === 'MAD'))) {
                  const d = new Date(value);
                  if (!isNaN(d)) value = d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
                }

                if (currentSource === 'commande_en_rupture' && ['Commande', 'Stock', 'Rupture'].includes(col)) {
                  if (value !== null && value !== undefined && value !== '') value = Math.round(Number(value));
                  if (col === 'Rupture') style.backgroundColor = '#f8d7da';
                  if (col === 'Stock' && Number(value) > 0) style.backgroundColor = '#fff3cd';
                }

                if (col === 'Statut') {
                  if (currentSource === 'commande_a_10_jours') {
                    let bgStyle = {};
                    if (value === 'Couvert par le stock') bgStyle.backgroundColor = '#fff9c4';
                    else if (value === 'Risque de rupture') bgStyle.backgroundColor = '#f8d7da';
                    else if (value === 'Préparée') bgStyle.backgroundColor = '#d4edda';
                    return <td key={j} style={bgStyle}>{value}</td>;
                  } else {
                    return (
                      <td key={j} className={
                        value === 'ouvert'   ? 'statut-ouvert'  :
                        value === 'en cours' ? 'statut-encours' :
                        value === 'soldé'    ? 'statut-solde'   : ''
                      }>
                        <select
                          value={value}
                          onChange={async (e) => {
                            const newStatut = e.target.value;
                            const newData = [...tableData];
                            newData[i]['Statut'] = newStatut;
                            setTableData(newData);
                            const commentaire = newData[i]['Commentaires'] || '';
                            const numeroTache = row['Numero tache'];
                            try {
                              await fetch(`${API}/taches/update`, {
                                method: 'PUT',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ numero_tache: numeroTache, commentaire, statut: newStatut }),
                              });
                              if (numeroTache.startsWith('A')) {
                                await fetch(`${API}/base_commentaire_animation/update`, {
                                  method: 'PUT',
                                  headers: { 'Content-Type': 'application/json' },
                                  body: JSON.stringify({ numero_tache: numeroTache, commentaire }),
                                });
                              }
                            } catch (err) { console.error('Erreur sauvegarde :', err); }
                          }}
                        >
                          <option value="ouvert">ouvert</option>
                          <option value="en cours">en cours</option>
                          <option value="soldé">soldé</option>
                        </select>
                      </td>
                    );
                  }
                }

                if (col === 'Commentaires') {
                  return (
                    <td key={j}>
                      <textarea
                        value={value || ''}
                        onChange={(e) => {
                          const newData = [...tableData];
                          newData[i]['Commentaires'] = e.target.value;
                          setTableData(newData);
                        }}
                        onBlur={() => {
                          const currentRow = tableData[i];
                          const payload = {
                            numero_tache: currentRow['Numero tache'],
                            commentaire: currentRow['Commentaires'] || '',
                            statut: currentRow['Statut'] || 'ouvert',
                          };
                          fetch(`${API}/taches/update`, {
                            method: 'PUT',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(payload),
                          })
                            .then(res => res.json())
                            .then(() => console.log('Mise à jour commentaire OK', payload.numero_tache))
                            .catch(err => console.error('Erreur update commentaire:', err));
                          if (currentRow['Numero tache'].startsWith('A')) {
                            fetch(`${API}/base_commentaire_animation/update`, {
                              method: 'PUT',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({
                                numero_tache: currentRow['Numero tache'],
                                commentaire: currentRow['Commentaires'] || '',
                              }),
                            }).catch(err => console.error('Erreur base_commentaire_animation:', err));
                          }
                        }}
                        placeholder="Ajouter un commentaire"
                        className="rc-textarea"
                      />
                    </td>
                  );
                }

                if (col === 'Description') {
                  return (
                    <td key={j} style={{ ...style, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                      {value != null && String(value).includes('Commentaire :') ? (
                        <>
                          {String(value)
                            .split(/(Commentaire\s*:\s*[\s\S]*)/)
                            .map((part, idx) =>
                              /Commentaire\s*:\s*[\s\S]+/.test(part)
                                ? <span key={idx} style={{ color: 'red', fontWeight: 'bold' }}>{part}</span>
                                : <span key={idx}>{part}</span>
                            )}
                        </>
                      ) : value}
                    </td>
                  );
                }

                return <td key={j} style={style}>{value}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  // ---------------------------
  // RENDER
  // ---------------------------
  return (
    <div className="rc-page">

      {/* Bandeau titre */}
      <div className="rc-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div className="rc-header-accent" />
          <span className="rc-header-title">Relation client — ADV</span>
        </div>

        {/* ── Bouton mode d'emploi PDF ── */}
        <a
          href="/mode_emploi_relation_client.pdf"
          target="_blank"
          rel="noopener noreferrer"
          download
          onMouseEnter={() => setPdfBtnHovered(true)}
          onMouseLeave={() => setPdfBtnHovered(false)}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 7,
            padding: '6px 14px',
            borderRadius: 8,
            background: pdfBtnHovered ? '#EFF6FF' : '#F8FAFC',
            border: `1px solid ${pdfBtnHovered ? '#1976D2' : '#E5E7EB'}`,
            color: pdfBtnHovered ? '#1565C0' : '#374151',
            fontSize: 13,
            fontWeight: 500,
            textDecoration: 'none',
            cursor: 'pointer',
            transition: 'all 0.15s',
            flexShrink: 0,
          }}
        >
          {/* Icône document PDF */}
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <polyline points="10 9 9 9 8 9"/>
          </svg>
          Mode d'emploi
          {/* Icône téléchargement */}
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.45 }}>
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
        </a>
      </div>

      {/* Grille de cards */}
      <div className="rc-cards-grid">
        {[
          { hovered: card11Hovered, setHovered: setCard11Hovered, source: 'offre',               Component: Card11 },
          { hovered: card12Hovered, setHovered: setCard12Hovered, source: 'commande_en_rupture', Component: Card12 },
          { hovered: card13Hovered, setHovered: setCard13Hovered, source: 'commande_a_10_jours', Component: Card13 },
          { hovered: card14Hovered, setHovered: setCard14Hovered, source: 'commande_en_retard',  Component: Card14 },
          { hovered: card28Hovered, setHovered: setCard28Hovered, source: 'taches',              Component: Card28 },
        ].map(({ hovered, setHovered, source, Component }) => (
          <div
            key={source}
            className={`rc-card-wrap ${hovered ? 'rc-card-wrap--hovered' : ''}`}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onClick={() => handleCardClick(source)}
          >
            <Component />
          </div>
        ))}
      </div>

      {/* Graphes */}
      {!showTable && (
        <div className="rc-graphs">
          <div className="rc-graph-bar"><Graph1 /></div>
          <div className="rc-graph-pie"><Camembert1 /></div>
        </div>
      )}

      {/* Tableau */}
      {showTable && (
        <div className="table-offre-container">
          {currentSource === 'offre' ? renderTableOffre() : renderTable()}
        </div>
      )}

    </div>
  );
};

export default Relationclient;